module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vwassets/new2/_next/static/images/slideshow-singlepage-2-0823a03732ad75b885d26e0ac6dd2c96.jpg";